import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import SurveyStatisticsQuestionChoice from './models/questionChoice';
import './questionChoice.html';
import './questionChoice.scss';

components.preload('wcc-content');

interface SurveyStatisticsQuestionChoiceVMConfig {
    choice: SurveyStatisticsQuestionChoice
}

@injectable()
export default class SurveyStatisticsQuestionChoiceVM {
    title: Subscribable<string | undefined>
    value: Subscribable<string | undefined>
    rank: Subscribable<string | undefined>

    scoremode: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) { choice }: SurveyStatisticsQuestionChoiceVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.title = choice.title;
        this.value = choice.value;
        this.rank = choice.rank;

        this.scoremode = choice.scoremode;

        ko.applyBindingsToNode(info.element, {
            'survey-statistics__question__choice': true
        });
    }
}